import React, { useEffect } from 'react';
import { speedbumpModal, useModal } from '../../providers/Modal/Modal';

export const MessageWrapper = (props: any) => {

    const { setModalContent, toggleModal, setModalClass } = useModal();

    useEffect(() => {
        const messageListener = (e: MessageEvent) => {
            const data = e.data;
            if (typeof data === 'object' && data.event === 'Speedbump') {
                setModalClass('Speedbump');
                setModalContent(speedbumpModal(toggleModal, data.width, data.target, data.externalUrl, data.title, data.content));
                toggleModal();
            }
            if (typeof data === 'object' && data.event === 'WrapperRedirect') {
                window.open(data.url, data.target);
            }
        };
        window.addEventListener('message', messageListener);
        return () => window.removeEventListener('message', messageListener);
    }, []);

    return (
        <React.Fragment>
            {props.children}
        </React.Fragment>
    );
};